export default __webpack_public_path__ + "static/media/fullTime.e9fcb5d4.svg";